import React from 'react'
import Footer from '../../Components/FooterComponent/Footer'
import Navbar from '../../Components/NavBarComponent/NavBar'
import PrivacyText from './PrivacyText'


function Privacy() {
  return (
    <div>
        <Navbar/>
        <PrivacyText/>  
        <Footer/>
    </div>
  )
}

export default Privacy
